import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import location from './modules/location';
import hotels from './modules/hotels';
import bookings from './modules/bookings';
import availability from './modules/availability';
import global from './modules/global';
import inventory from './modules/inventory';
import logs from './modules/logs';
import logstock from './modules/logstock';
import rates from './modules/rates';
import rateplans from './modules/rateplans';
import childpolicies from './modules/childpolicies';
import dashboard from './modules/dashboard';
import integrations from './modules/integrations';
import mails from './modules/mails';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules : {
        availability,
        auth,
        bookings,
        global,
        hotels,
        inventory,
        location,
        logs,
        logstock,
        rates,
        rateplans,
        childpolicies,
        dashboard,
        integrations,
        mails
    }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js